import type { SubscriptionStore } from '@stores/subscription/interfaces'

import { useSubscriptionStore } from '@stores/subscription'
import { useDisciplineStore } from '@stores/discipline'

interface SubscriptionListReturn {
  loading: ComputedRef<SubscriptionStore['loading']>
  hasData: ComputedRef<boolean>
  subscriptions: ComputedRef<SubscriptionStore['subscriptions']>
}

export const useSubscriptionList = (): SubscriptionListReturn => {
  const subscriptionStore = useSubscriptionStore()
  const disciplineStore = useDisciplineStore()

  watch(
    () => disciplineStore.activeDiscipline?.id,
    (newId, oldId) => {
      if (!newId) return

      if (oldId) {
        subscriptionStore.clear()
      }

      void subscriptionStore.ensure()
    },
    { immediate: true },
  )

  return {
    loading: computed(() => subscriptionStore.isLoading),
    hasData: computed(() => subscriptionStore.hasData),
    subscriptions: computed(() => subscriptionStore.getSubscriptions),
  }
}
